import { eventLabelConnectedDevices, formatConnectedDevices, normalizeAlternatives, normalizeString, setActivitiesToDoAlternative } from "../common";

const AdviserHasOpenedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - apertura',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'arma la solucion ideal para tu negocio',
});
}

const StartButtonGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - apertura - btn',
    'eventAction': 'click to action', 
    'eventLabel': 'quiero comenzar',
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'arma la solucion ideal para tu negocio',
});
}

const ServicesTypeScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - servicios',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'tipo de servicio',
});
}

const QuestionsButtonGTM = (window: any, textButton: string, selectedPlan: string, questionId: number, connectedDevices: string, activities: any) => {
  window.dataLayer = window.dataLayer || [];
  let formName = "";
  let value = "";
  if (questionId === 1) 
    {formName = "tipo de servicio";
    value = "servicios"
  }
  if (questionId === 2 || questionId === 3 || questionId === 4) {
    formName = "dispositivos conectados";
    value = "dispositivos"
  }
  if (questionId === 5 || questionId === 6) {
    formName = "actividades a realizar";
    value = "actividades"
  }
  
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': `recomendador - ${value} - btn`,
    'eventAction': 'click to action', 
    'eventLabel': eventLabelConnectedDevices(textButton),
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': formName,
  	'eventPlan': normalizeString(selectedPlan)
  };
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  if (questionId !== 1) {
    obj["variant"] = connectedDevicesCopy;
    if (obj["variant"] === "Xentre 8 y 16" || obj["variant"] === "mas de 16") {
      obj["variant2"] = "no aplica";
    }
  }
  if (questionId === 5 || questionId === 6) obj["variant2"] = normalizeAlternatives(activities);
  // if (questionId === 5) delete obj["variant"];
  if (questionId === 5) {
    obj["variant"] = "no aplica";
    if (normalizeString(selectedPlan) === "internet + telefonia") obj["variant"] = connectedDevicesCopy;
  }
  window.dataLayer.push(obj);
}

const ConnectedDivicesUploadedGTM = (window: any, planSelected: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - dispositivos',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'dispositivos conectados',
    'eventPlan': normalizeString(planSelected), 
});
}

const ServiceTypeAlternativeSelectedGTM = (window: any, title: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - servicios - checkbox',
    'eventAction': 'interaction', 
    'eventLabel': normalizeString(title),
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'tipo de servicio',
});
}

const ConnectedDivicesAlternativeSelectedGTM = (window: any, title: string, selectedPlan: string) => {
  window.dataLayer = window.dataLayer || [];
  const eventPlan = eventLabelConnectedDevices(title) || "";
  window.dataLayer.push({
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - dispositivos - checkbox',
    'eventAction': 'interaction', 
    'eventLabel': normalizeString(eventPlan),
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'dispositivos conectados',
    'eventPlan': normalizeString(selectedPlan),
});
}

const ActivitiesToDoScreenUploadedGTM = (window: any, planSelected: string, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  const eventPlan = normalizeString(planSelected);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - actividades',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'actividades realizadas', 
    'eventPlan': normalizeString(planSelected), 
    'variant': connectedDevicesCopy
  };
  if (eventPlan !== "internet + telefonia + tv") {
    window.dataLayer.push(obj);
  } else {
    // delete obj["variant"];
    obj["variant"] = "no aplica";
    window.dataLayer.push(obj);
  }
}

const ActivitiesToDoAlternativeSelectedGTM = (window: any, title: any, selectedPlan: string, connectedDevices: string) => {
  let value = setActivitiesToDoAlternative(title);
  window.dataLayer = window.dataLayer || [];
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - actividades - checkbox',
    'eventAction': 'interaction', 
    'eventLabel': value,
    'origen': 'entel.cl',
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'actividades realizadas',
    'eventPlan': normalizeString(selectedPlan)
  };
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  if (normalizeString(selectedPlan) !== "internet + telefonia + tv") {
    obj["variant"] = connectedDevicesCopy;
  }
  window.dataLayer.push(obj);
}

const EmailScreenUploadedGTM = (window: any, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let bufferEventPlan = normalizeString(selectedPlan);
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - ultimo paso',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'ultimo paso', // en este caso 'ultimo paso'
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives)
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    if (obj["variant"] === "21 a 30" || obj["variant"] === "mas de 16") {
      obj["variant2"] = "no aplica";
    }
    // window.dataLayer.push(obj);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else if (eventPlant === "telefonia") {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  } else {
    if (obj["variant"] === "21 a 30" || obj["variant"] === "mas de 16") {
      obj["variant2"] = "no aplica";
    }
    // window.dataLayer.push(obj);
  }
  window.dataLayer.push(obj);
}

const PolicyAcceptedGTM = (window: any, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - ultimo paso - checkbox',
    'eventAction': 'interaction', 
    'eventLabel': 'acepto las politicas',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'ultimo paso', // en este caso 'ultimo paso'
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives)
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } 
  else {
    delete obj.variant;
    delete obj.variant2;
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const PolicyReadedGTM = (window: any, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDNIevent',
    'eventCategory': 'recomendador - ultimo paso - link',
    'eventAction': 'interaction', 
    'eventLabel': 'acepto las politicas',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'ultimo paso', // en este caso 'ultimo paso'
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives)
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const CapturedDataGTM = (window: any, email: string, phone: string, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - ultimo paso - btn',
    'eventAction': 'click to action', 
    'eventLabel': 'quiero continuar',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'ultimo paso', // en este caso 'ultimo paso'
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv")  {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const RecommendationGeneratedGTM = (window: any, email: string, phone: string, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDIevent',
    'eventCategory': 'recomendador - plan final',
    'eventAction': 'info', 
    'eventLabel': 'carga',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'plan recomendado',
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const SelectedServiceGTM = (window: any, selectedPlan: string, email: string, phone: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - plan final - btn',
    'eventAction': 'click to action', 
    'eventLabel': 'quiero contratar',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'plan recomendado',
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const CheckFeasibilityGTM = (window: any, email: string, phone: string, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - plan final - btn',
    'eventAction': 'click to action', 
    'eventLabel': 'revisa tu factibilidad',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'plan recomendado',
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const StartAgainGTM = (window: any, email: string, phone: string, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - plan final - btn',
    'eventAction': 'click to action', 
    'eventLabel': 'volver a empezar',
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'plan recomendado',
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  } else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

const RateSelectedGTM = (window: any, rate: number, email: string, phone: string, selectedPlan: string, alternatives: any, connectedDevices: string) => {
  window.dataLayer = window.dataLayer || [];
  let encodeEmail = btoa(email) || ""
  let encoodePhone = btoa(phone) || ""
  const eventPlant = normalizeString(selectedPlan);
  const connectedDevicesCopy:string = formatConnectedDevices(connectedDevices);
  let obj: any = {
    'event' : 'GARDevent',
    'eventCategory': 'recomendador - plan final - valoracion',
    'eventAction': 'interaction', 
    'eventLabel': `estrellas ${rate}`,
    'origen': 'entel.cl', //EJ Entel.cl
    'segmento': 'fijo', 
    'mercado': 'emp', 
    'page_owner': 'publico',
    'visitor_type' : 'no cliente',
    'form_name': 'plan recomendado',
    'eventPlan': normalizeString(selectedPlan), 
    'variant': connectedDevicesCopy, 
    'variant2': normalizeAlternatives(alternatives),
    'email': `${encodeEmail}`,//encriptado en base 64
    'telefono_cliente': encoodePhone,//encriptado en base 64 
  };
  if (eventPlant !== "telefonia" && eventPlant !== "internet + telefonia + tv") {
    // window.dataLayer.push(obj);
    obj["variant"] = connectedDevicesCopy;
    obj["variant2"] = normalizeAlternatives(alternatives);
  } else if (eventPlant === "internet + telefonia + tv") {
    // delete obj.variant;
    obj.variant = "no aplica";
    // window.dataLayer.push(obj);
  }else {
    delete obj.variant;
    delete obj.variant2;
    // window.dataLayer.push(obj);
  }

  if (obj["variant2"] === "") obj["variant2"] = "no aplica";
  window.dataLayer.push(obj);
}

export {
  AdviserHasOpenedGTM,
  StartButtonGTM,
  ServicesTypeScreenUploadedGTM,
  QuestionsButtonGTM,
  ConnectedDivicesUploadedGTM,
  ServiceTypeAlternativeSelectedGTM,
  ConnectedDivicesAlternativeSelectedGTM,
  ActivitiesToDoScreenUploadedGTM,
  ActivitiesToDoAlternativeSelectedGTM,
  PolicyAcceptedGTM,
  PolicyReadedGTM,
  CapturedDataGTM,
  RecommendationGeneratedGTM,
  CheckFeasibilityGTM,
  SelectedServiceGTM,
  StartAgainGTM,
  RateSelectedGTM,
  EmailScreenUploadedGTM
}